var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('div',{staticClass:"vue-back-to-top",staticStyle:{"cursor":"auto"},style:(`bottom:${_vm.visible ? this.bottom2 : this.bottom};right:${this.right};`)},[_vm._t("default",function(){return [_c('div',{staticClass:"default"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.text)+"\n        ")])])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }